import { render, staticRenderFns } from "./gateway-filter.vue?vue&type=template&id=bc42ecf4"
import script from "./gateway-filter.vue?vue&type=script&lang=js"
export * from "./gateway-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports